import { useCallback } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ArticleForm } from '../hooks/useArticleSheet.hook';
import { MarkdownEditor } from './MarkdownEditor/MarkdownEditor';
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/Domain/components/Shared/Form/Form';
import { Input } from '@/Domain/components/Shared/Input/Input';

interface ArticleFormProps {
  form: UseFormReturn<ArticleForm>;
}

export const ArticleFormContent = ({ form: _form }: ArticleFormProps) => {
  const { t } = useTranslation(['knowledge_base']);
  const handleContentNormalized = useCallback(
    (normalized: string) => {
      const current = _form.getValues();
      if (current.content === normalized) return;
      _form.reset({ ...current, content: normalized });
    },
    [_form],
  );

  return (
    <section className="flex h-full min-h-0 min-w-0 flex-col space-y-8 pt-4 pb-2 lg:pt-6 lg:pb-0">
      <div className="min-w-0">
        <FormField
          name="title"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t('knowledge_base:article.title')}</FormLabel>
              <FormDescription>{t('knowledge_base:article.title_description')}</FormDescription>
              <FormControl>
                <Input
                  placeholder={t('knowledge_base:article.title_placeholder')}
                  {...field}
                  value={field.value ?? ''}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      <div className="flex-1 flex flex-col min-w-0 min-h-0 pr-1 !custom-scroll">
        <FormField
          name="content"
          render={({ field }) => (
            <FormItem className="flex-1 flex flex-col min-w-0 min-h-0 custom-scroll">
              <FormLabel>{t('knowledge_base:article.content')}</FormLabel>
              <FormDescription>{t('knowledge_base:article.content_description')}</FormDescription>
              <FormControl>
                <MarkdownEditor
                  field={field}
                  placeholder={t('knowledge_base:article.content_placeholder')}
                  onContentNormalized={handleContentNormalized}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </section>
  );
};
